module.exports = __webpack_public_path__ + "img/icon-trash-line.94532ddd.svg";